module.exports = __webpack_public_path__ + "img/visualizadas-trilha-dashboard.696e955c.svg";